<template>
	<th
		:style="[
			{
				'background-color': col.backgroundColor,
			},
			noChildren(col) ? styleWidth : {},
		]"
		:class="[
			col.cssCellClass,
			{ 'ms-pos-relative': col.align == 'center' },
			noChildren(col) ? 'ms-th-group-position' : 'border-right-none',
			{
				'border-right-none': col.lastColParent || col.lastColChildren,
			},
		]"
		@click="sort(col)"
		@mouseover="showButtonHeaderFilter()"
		@mouseleave="checkHideButtonHeaderFilter()"
	>
		<div v-if="col.isAva" :class="col.iconAVA"></div>
		<div
			class="justify-start flex align-center h-full"
			:class="`justify-${col.align == 'right' ? 'end' : col.align || 'start'}`"
		>
			<span
				class="ms-th-title"
				:class="[`text-${col.align || 'left'}`]"
				v-tooltip="col.tooltip"
			>
				<div class="align-center">
					<span
						:class="col.iconBeforeTitle"
						v-tooltip="col.tooltipIconBeforeTitle"
						v-if="col.iconBeforeTitle"
					></span>
					<span
						v-if="!col.isIcon"
						:class="[
							{
								'flex align-center justify-center ms-minH-36px border-th-group-bottom border-right-th-parent':
									!noChildren(col),
							},
							{
								'border-right-none': col.lastColParent,
							},
						]"
					>
						{{
							customGridLayout &&
							customGridLayout.i18n &&
							customGridLayout.layoutID
								? $t(`${customGridLayout.i18n}.${customGridLayout.layoutID}`)[
										`${col.title}`
								  ]
								: col.title
						}}
					</span>
					<span
						class="col-icon-after-title"
						:class="col.iconAfterTitle"
						v-tooltip="col.tooltipIconAfterTitle"
						v-if="col.iconAfterTitle"
						@click="onClickiconAfterTitle"
					>
					</span>
					<div v-if="!noChildren(col)" class="col-child">
						<ms-th-group
							v-for="(child, childIndex) in col.children"
							:col="child"
							:key="child.dataField"
							:style="[
								{
									'background-color': child.backgroundColor,
								},
							]"
							:resizeCol="true"
							:customGridLayout="customGridLayout"
							:class="[]"
							@sort="sort"
							@click.stop="sort(child)"
							:sortCol="child.isSort"
							:sortCondition="sortCondition"
						>
						</ms-th-group>
					</div>
				</div>
			</span>

			<div
				v-if="
					col.isSort &&
					sortCondition &&
					sortCondition.sortStatus != $ms.enum.SortStatus.none &&
					sortCondition.col &&
					sortCondition.col.dataField == col.dataField
				"
				class="ms-pdl-8px"
			>
				<div
					v-show="sortCondition.sortStatus == $ms.enum.SortStatus.desc"
					class="mi mi-8 mi-icon-arrow-down-sort"
				></div>

				<div
					v-show="sortCondition.sortStatus == $ms.enum.SortStatus.asc"
					class="mi mi-8 mi-icon-arrow-up-sort"
				></div>
			</div>
			<div
				:title="$t('i18nCommon.Filter')"
				class="mi-new-v2 mi-16 ms-pos-absolute"
				:class="
					thOptionClass ? 'mi-icon-v2-filter-active' : 'mi-icon-v2-filter'
				"
				v-show="showOption"
				@click="optionClick"
			></div>
			<div
				class="ms-resize"
				@mousedown="resizeOn"
				v-if="resizeCol && !isNotResizeCol && noChildren(col)"
			></div>
		</div>
	</th>
</template>
<script>
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import store from '@/store/store';
import filterHeaderUtil from '@/common/filterHeaderUtil';

export default {
	name: 'msThGroup',
	props: {
		col: {},
		data: {},
		sortCondition: {},
		resizeCol: {
			default: true,
			type: Boolean,
		},
		sortCol: {
			default: false,
			type: Boolean,
		},
		name: {
			default: '',
			type: String,
		},
		isCreate: {
			default: false,
			type: Boolean,
		},
		customGridLayout: {},
		/**
		 * có filter cột không
		 */
		filterable: {
			type: Boolean,
			default: true,
		},
		/**
		 * Danh sách lọc trên các cột
		 */
		filterHeaders: {
			type: Array,
			return: () => [],
		},
		/**
		 * truncateOverflow truyền từ grid cha: đồng bộ max-width header với td
		 * để header không lệch body khi td bị chặn giãn
		 */
		truncateOverflow: {
			default: true,
			type: Boolean,
		},
	},
	created() {
		const me = this;
		me.widthx = me.col._width ? me.col._width : me.col.width;
		me.checkShowButtonFilter();
	},
	computed: {
		styleWidth() {
			const me = this;
			let minWidth = me.col._minWidth || me.col._width;
			if (me.col.freezeWidth) {
				return {
					width: me.col.width + 'px',
					'min-width': me.col.width + 'px',
				};
			}

			if (me.col.autoResize) {
				/* truncateOverflow: đồng bộ với msTr.vue/msTh.vue nhánh autoResize — khi flag bật,
				   cột autoResize cũng nhận max-width+overflow:hidden để truncate text. autoResize
				   chỉ giữ fill-space (không max-width) khi truncateOverflow=false. */
				let style = {
					'min-width': minWidth + 'px',
				};
				if (me.isTruncateEligible(me.col)) {
					style['max-width'] = me.col._width + 'px';
					style['overflow'] = 'hidden';
				}
				return style;
			}
			let style = {
				width: me.col._width + 'px',
				'min-width': minWidth + 'px',
			};
			/* truncateOverflow: áp max-width + overflow:hidden cho cột TEXT thuần và cột template
			   khai báo col.truncate=true (opt-in) — đồng bộ với msTr.vue styleWidth */
			if (me.isTruncateEligible(me.col)) {
				style['max-width'] = me.col._width + 'px';
				style['overflow'] = 'hidden';
			}
			return style;
		},

		/**
		 * Cột có được phép không có giãn hay không
		 * true : không có giãn
		 * false: có co giãn
		 */
		isNotResizeCol() {
			const me = this;
			if (!me.col) return true;
			if (me.col && me.col.notResize) return true;
			return false;
		},
	},
	watch: {
		cursorX() {
			const me = this;
			let offsetX = me.resizeX - me.cursorX;
			if (!me.col.minW) {
				me.$set(me.col, 'minW', 80);
			}

			if (
				me.defaultwidth - offsetX >= me.col.width ||
				(me.col.minW && me.defaultwidth - offsetX >= me.col.minW)
			) {
				me.widthx = me.defaultwidth - offsetX;
			} else {
				// Giới hạn việc kéo đến min
				if (
					me.defaultwidth - offsetX < me.col.minW &&
					me.widthx >= me.col.minW
				) {
					me.widthx = me.col.minW;
				} else {
					me.widthx = me.col.width;
				}
			}
			me.$set(me.col, '_width', me.widthx);
			me.$set(me.col, '_minWidth', me.widthx);
		},
	},
	data() {
		return {
			cursorX: 0,
			widthx: 0,
			sortStatus: this.$ms.enum.SortStatus.none,
			isActionSort: true,
			showOption: false,
			showAllIconFilter: false,
			thOptionClass: null,
		};
	},
	methods: {
		/**
		 * Có danh sách con
		 */
		noChildren(col) {
			return !col.children || col.children.length <= 0;
		},

		checkShowButtonFilter() {
			const me = this;
			if (me.filterHeaders && me.filterHeaders.length > 0) {
				let check = me.filterHeaders.find(
					(x) => x.FieldName == me.col.dataField
				);
				if (check != null) {
					me.showOption = true;
					me.col.hasActionFilter = true;
				}
			}
		},

		remoteSort(col) {
			const me = this;
			if (me.col != col) {
				me.sortStatus = me.$ms.enum.SortStatus.none;
			}
		},
		sort(col) {
			const me = this;
			//Click icon trên tiêu đề cột là không được sort cột
			if (!me.isActionSort) {
				me.isActionSort = true;
				return;
			}
			// return;
			if (me.sortCol) {
				me.remoteSort(me.sortCondition.col);

				if (me.sortCondition && me.col) {
					if (!me.sortCondition.col) {
						me.$emit('setSortCondition', {
							sortStatus: me.$ms.enum.SortStatus.none,
							col: col,
						});
					}
					if (
						me.sortCondition.col &&
						me.sortCondition.col.dataField &&
						me.sortCondition.col.dataField == col.dataField
					) {
						me.sortStatus = me.sortCondition.sortStatus;
					}
					me.sortStatus += 1;
					if (me.sortStatus > me.$ms.enum.SortStatus.asc) {
						me.sortStatus = me.$ms.enum.SortStatus.none;
					}
					EventBusGlobal.$emit(GlobalEventName.setRememberSort + `${me.name}`, {
						mode: me.sortStatus,
						col: col,
					});
					me.$emit('sort', col, me.sortStatus);
				}
			}
		},
		testRender() {},
		//Bắt đầu co kéo cột
		resizeOn(event) {
			const me = this;
			this.$nextTick(() => {
				this.defaultwidth = this.$el.offsetWidth;
				if (!this.minWidthx) {
					this.minWidthx = this.col._minWidth || this.col.width;
				}
			});
			this.resizeX = event.screenX;
			me.$emit('resizeOn', this.col);
			document.addEventListener('mousemove', this.mousemove);
		},
		//Di chuyển co kéo cột
		mousemove(e) {
			const me = this;
			me.cursorX = e.screenX;
			me.$emit('resizeMove', this.col);
			if (!me.isResizeActive) {
				me.isResizeActive = true;
				document.addEventListener('mouseup', me.resizeOff);
			}
		},
		//Ngừng co kéo cột
		resizeOff() {
			const me = this;
			me.$emit('resizeOff', me.col);
			EventBusGlobal.$emit(GlobalEventName.ResizeMsThGroup);
			document.removeEventListener('mousemove', me.mousemove);
			me.closeResizeOff();
			me.isResizeActive = false;
		},
		closeResizeOff() {
			document.removeEventListener('mouseup', this.resizeOff);
		},
		//Update lại động rộng của cột
		updateColWidth(autoResize) {
			const me = this;
			if (me.$el) {
				me.minWidth = me.col.width;
				me.$set(me.col, '_width', me.$el.offsetWidth);
				// me.widthx = me.$el.offsetWidth;
				me.$set(me.col, 'autoResize', autoResize);
			}
		},

		onClickiconAfterTitle() {
			const me = this;
			me.isActionSort = false;
			me.$emit('onClickiconAfterTitle');
		},

		/**
		 * Kiểm tra hiển thị menu lọc và cố định cột trên header grid
		 */
		showButtonHeaderFilter() {
			let me = this;
			if (
				me.filterable &&
				(me.col.isFilter || me.col.hasActionFilter || me.thOptionClass)
			) {
				me.showOption = true;
			} else {
				me.showOption = false;
			}
		},

		checkHideButtonHeaderFilter() {
			let me = this;
			if (this.col.hasActionFilter || this.thOptionClass) {
				this.showOption = true;
			} else {
				this.showOption = false;
			}
		},

		/**
		 * click vào icon option
		 */
		optionClick(e) {
			const me = this;
			e.preventDefault();
			if (!me.filterable) return;
			me.isActionSort = false; //Cờ cắm để không sort cột
			let col = me.col,
				filterHeaders = me.filterHeaders;
			if (filterHeaders && filterHeaders.length > 0 && col) {
				let filted = filterHeaders.find((x) => x.FieldName === col.dataField);
				if (filted) {
					me.col.filter.value = filted.Value;
					me.col.hasActionFilter = me.col.hasActionFilter
						? me.col.hasActionFilter
						: filted.hasActionFilter;
				}
			}
			filterHeaderUtil.showOption(this, this.col, this.isLock);
		},
		/**
		 * Kiểm tra cột có đủ điều kiện truncate (có thể bị cắt text) — dùng trong updated() để giới hạn
		 * check overflow chỉ cho cột truncate-eligible, tránh overhead duyệt toàn bộ cột.
		 */
		isTruncateEligible(col) {
			const me = this;
			if (!me.truncateOverflow) return false;
			// col.truncate opt-in hoặc cột text thuần (không template/icon/serial/html)
			return (
				col.truncate ||
				(!col.template && !col.isIcon && !col.isSerial && !col.isHtmlText)
			);
		},
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msgridviewer/msGridViewerV2.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msgridviewer/msGridViewerV2.scss';
}
.ms-pos-absolute {
	position: absolute;
	right: 2px;
	top: 10px;
}
.hidden {
	visibility: hidden;
}
.attachfile-invoice {
	padding: 6px !important;
	width: 37px !important;
	min-width: 37px !important;
}
.pdf-invoice {
	padding: 6px !important;
}
th {
	padding: 0px !important;
}

.ms-th-title:last-child {
	padding: 0 6px !important;
	height: 36px !important;
}

.ms-th-group-position {
	position: relative !important;
	padding: 6px 10px !important;
	height: 36px !important;
}

.border-th-group-bottom {
	border-bottom: 1px solid var(--ms-color-border);
}
</style>